import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "admin-landing" };
const _hoisted_2 = {
    class: "section-content centered",
    key: "admin-landing-page"
};
const _hoisted_3 = ["src"];
import { onMounted } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AdminLandingPage',
    setup(__props) {
        onMounted(() => {
            console.log('Admin Landing Page loaded');
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_Transition, { mode: "out-in" }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                            _cache[0] || (_cache[0] = _createElementVNode("h1", null, "Money Guided Admin Home", -1)),
                            _cache[1] || (_cache[1] = _createElementVNode("p", null, "Choose what you would like to do from the side menu", -1)),
                            _cache[2] || (_cache[2] = _createElementVNode("p", null, "This is Peg. Peg says \"Hi\".", -1)),
                            _cache[3] || (_cache[3] = _createElementVNode("p", null, "She will now read your fortune... please wait...", -1)),
                            _createElementVNode("img", {
                                src: require('@/admin/assets/WomanMGChill.svg'),
                                class: "peg-image"
                            }, null, 8, _hoisted_3)
                        ])
                    ]),
                    _: 1
                })
            ]));
        };
    }
});
